import { useMemo } from "react";
import Breadcrumbs from "@/components/base/Breadcrumbs";
import ClueFilterList from "@/components/feature/ClueFilterList";
import { useSeo } from "@/hooks/useSeo";
import { clues } from "@/mocks/clues";

function CluesPage() {
  const jsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "线索归档 - 爆料平台",
      description: "浏览爆料平台已归类的公开线索，支持按主题筛选与关键词搜索。",
      url: "https://gregbennettguitars.com.cn/clues",
      inLanguage: "zh-CN",
      mainEntity: {
        "@type": "ItemList",
        numberOfItems: clues.length,
        itemListElement: clues.map((clue, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: clue.title,
          url: `https://gregbennettguitars.com.cn/clue/${clue.slug}`,
        })),
      },
    }),
    []
  );

  useSeo({
    title: "线索归档 - 全部公开爆料与内部消息 | 爆料平台",
    description:
      "爆料平台线索归档页，汇总已归类的公开线索，涵盖内部消息、公众事件、身边事、维权线索、消费投诉与行业观察，支持按主题筛选与关键词搜索。",
    keywords: "线索归档,爆料平台,匿名爆料,公开线索,内部消息",
    path: "/clues",
    jsonLd,
  });

  return (
    <div className="w-full bg-background-50">
      <div className="border-b border-background-200 bg-background-100">
        <div className="w-full px-4 py-10 md:px-8 md:py-14">
          <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "线索归档" }]} />
          <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            线索归档
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里汇总平台已归类整理的公开线索。每条内容都标注了来源区域、提交时间与核实状态，你可以按主题筛选，也可以直接搜索关键词。
          </p>
        </div>
      </div>

      <div className="w-full px-4 py-10 md:px-8 md:py-14">
        <ClueFilterList />
      </div>
    </div>
  );
}

export default CluesPage;